import { useState, useEffect } from "react";
import styled from "styled-components";
import client from "../../../axios";

// 데이터 타입 정의
interface Device {
  macAddr: string;
  alias: string;
  type: 'heating' | 'core';
  pattern: number;
}

const TableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
`;

export default function Devices() {
  const [devices, setDevices] = useState<Device[]>([]);

  // 1. 기기 목록 불러오기
  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = async () => {
    try {
      const res = await client.get('/api/temperature/device');
      setDevices(res.data);
    } catch (e) {
      console.error("기기 목록 로드 실패", e);
    }
  };

  // 2. 특정 셀(타입, 패턴)에 맞는 기기 찾기 헬퍼 함수
  const getDeviceAlias = (type: 'heating' | 'core', pattern: number) => {
    // 1. 해당 설비(pattern)와 타입(type)에 맞는 모든 기기 찾기 (filter)
    const targets = devices.filter(d => d.type === type && Number(d.pattern) === pattern);
    
    // 2. 기기가 없으면 하이픈 표시
    if (targets.length === 0) return '-';

    // 3. 기기가 있으면 이름(alias)만 뽑아서 콤마로 연결 (예: "곰탕솥, 떡시루")
    return targets.map(d => d.alias).join(', ');
  };

  // 설비 번호 배열 (1~4)
  const patterns = [1, 2, 3, 4];

  return (
    <div className="px-4 py-3">
      <TableWrapper>
        <table className="table table-bordered table-hover mb-0 text-center align-middle">
          <thead className="table-light">
            <tr>
              <th style={{ width: '20%' }}>구분</th>
              <th style={{ width: '40%' }}>가열온도측정용</th>
              <th style={{ width: '40%' }}>심부온도측정용</th>
            </tr>
          </thead>
          <tbody>
            {patterns.map((pattern) => (
              <tr key={pattern} style={{ height: '60px' }}>
                {/* 구분 컬럼 (설비 번호) */}
                <td className="fw-bold bg-light">
                  설비 {pattern}
                </td>

                {/* 가열 온도 컬럼 */}
                <td>
                  {getDeviceAlias('heating', pattern)}
                </td>

                {/* 심부 온도 컬럼 */}
                <td>
                  {getDeviceAlias('core', pattern)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableWrapper>
    </div>
  );
}